import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import { observer } from 'mobx-react-lite';
import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { FEE_UNIT_TYPES } from 'src/constants/feesSetting';
import { useStore } from 'src/stores';
import CustomFee from 'src/components/shared/CustomFee';
const BillingDetailsCustomFee = observer(props => {
  var _store$addNewProperty;
  const store = useStore();
  const _useTranslation = useTranslation(),
    t = _useTranslation.t;
  const customFee = props.customFee,
    handleChange = props.handleChange,
    label = props.label,
    lateFee = props.lateFee;
  const sign = store.enrollResident.customLateFeeSign;
  const propertyFee = (_store$addNewProperty = store.addNewProperty.feeStructureV2.getPropertyFee({
    feeName: "".concat(lateFee ? 'late' : 'admin', "Fee")
  })) === null || _store$addNewProperty === void 0 ? void 0 : _store$addNewProperty.value;
  const _useState = useState(''),
    _useState2 = _slicedToArray(_useState, 2),
    description = _useState2[0],
    setDescription = _useState2[1];
  const _useState3 = useState(customFee),
    _useState4 = _slicedToArray(_useState3, 2),
    feeValue = _useState4[0],
    setFeeValue = _useState4[1];
  const _useState5 = useState(false),
    _useState6 = _slicedToArray(_useState5, 2),
    isOpened = _useState6[0],
    setIsOpened = _useState6[1];
  useEffect(() => {
    setFeeValue(customFee);
  }, [customFee]);
  const getSign = v => lateFee && sign === FEE_UNIT_TYPES.percentage ? v + '%' : '$' + v;
  const feeText = () => {
    if (feeValue === null) {
      if (propertyFee === null) return 'Not set';else if (propertyFee >= 0) return getSign(propertyFee);
    } else if (feeValue >= 0) {
      return getSign(feeValue.toFixed(2));
    }
    return 'Not set';
  };
  const handleDiscardClick = () => {
    setFeeValue(customFee);
    setIsOpened(false);
  };
  const handleEditClick = () => setIsOpened(!isOpened);
  const handleRelink = () => {
    handleChange(null);
    setDescription('');
    if (lateFee) store.enrollResident.setCustomLateFeeSign(FEE_UNIT_TYPES.fixedAmount);
    setIsOpened(false);
  };
  const handleSaveClick = () => {
    handleChange(feeValue);
    setDescription(t('unit_modal.custom_fee'));
    setIsOpened(false);
  };
  const handleSignChange = (e, value) => store.enrollResident.setCustomLateFeeSign(value);
  return /*#__PURE__*/React.createElement(CustomFee, {
    customFee: customFee,
    description: description,
    feeText: feeText(),
    feeValue: feeValue,
    handleDiscardClick: handleDiscardClick,
    handleEditClick: handleEditClick,
    handleRelink: handleRelink,
    handleSaveClick: handleSaveClick,
    handleSignChange: handleSignChange,
    label: label,
    lateFee: lateFee,
    isOpened: isOpened,
    handleInputChange: v => setFeeValue(v),
    sign: sign
  });
});
export default BillingDetailsCustomFee;